export default __webpack_public_path__ + "assets/Acorns-b28349a8702e9e069434480a6269c8b4.svg";